import React, { useEffect, useRef, useState } from "react";
import "./CurrencyComponent.scss";
import "semantic-ui-css/semantic.min.css";
import axios from "axios";
import btcSVG from "../pic/btc.svg";
import irrSVG from "../pic/irr.svg";
import ethSVG from "../pic/eth.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SERVER, SITEURL } from "../../api";
import NumberFormat from 'react-number-format';
import useOnBlur from "../../util/useOnBlue";
import { Link } from "react-router-dom";


let destination = "BTC";
let sOurce = "IRT";

const CurrencyComponent = () => {
    const [active, setActive] = useState(1);
    const [isOpen, setOpen] = useState(false);
    const [isOpen2, setOpen2] = useState(false);
    const [name, setName] = useState("BTC");
    const [name2, setName2] = useState("IRT");
    const [subname, setSubname] = useState("بیت کوین");
    const [subname2, setSubname2] = useState("ریال\nایران");
    const [svg, setSvg] = useState(btcSVG);
    const [svg2, setSvg2] = useState(irrSVG);
    const [markets, setMarkets] = useState([]);
    const [marketstatic, setMarketsStatic] = useState([]);
    const source1 = useRef();
    const source2 = useRef();
    const inputRef2 = useRef();
    const inputRef = useRef();
    const [exChange, setexChange] = useState(null);
    const [process1, setProcess1] = useState(false);
    const [process2, setProcess2] = useState(false);
    const [firstInput, setFirstInput] = useState(undefined)
    const [secondInput, setSecondInput] = useState(undefined)
    const sourceDropDownRef = useRef()
    const destinationDropDownRef = useRef()
    const intervalRef = useRef(null);

    function purchaseRequestHandler() {
        window.location.replace('/authorization/')
    }

    useOnBlur(sourceDropDownRef, () => {
        if (isOpen)
            setOpen(false)
    })
    useOnBlur(destinationDropDownRef, () => {
        if (isOpen2)
            setOpen2(false)
    })

    function searchHandler(event) {
        let newList = [];
        if (event.target.value !== "") {
            newList = marketstatic.filter(item => {
                const name = item.name.toLowerCase();
                const symbol = item.symbol.toLowerCase();
                const filter = event.target.value.toLowerCase();

                return name.includes(filter) || symbol.includes(filter);
            });
            newList = newList.filter(item => item.symbol !== destination)
            setMarkets(newList);
        } else {
            setMarkets(marketstatic);
        }
    }

    function searchHandler2(event) {
        let newList = [];
        if (event.target.value !== "") {
            newList = marketstatic.filter(item => {
                const name = item.name.toLowerCase();
                const symbol = item.symbol.toLowerCase();
                const filter = event.target.value.toLowerCase();
                return name.includes(filter) || symbol.includes(filter);
            });
            newList = newList.filter(item => item.symbol !== sOurce)
            setMarkets(newList);
        } else {
            setMarkets(marketstatic);
        }
    }

    function xToyValue(which, e) {
        if (intervalRef.current) {
            clearTimeout(intervalRef.current);
        }

        let _firsInput;
        let _secondInput;

        if (which === 1) {
            // _firsInput = source1.current.value.replaceAll(',', '');
            _firsInput = e
            setFirstInput(_firsInput)
            // setProcess2(true);
        } else {
            //_secondInput = source2.current.value.replaceAll(',', '')
            _secondInput = e
            setSecondInput(_secondInput)
            // setProcess1(true)
        }

        if ((which === 1 && _firsInput) || (which === 2 && _secondInput)) {
            //return null


            if (which === 1) {
                // _firsInput = source1.current.value.replaceAll(',', '');
                // _firsInput = e
                //   setFirstInput(_firsInput)
                setProcess2(true);
            } else {
                //_secondInput = source2.current.value.replaceAll(',', '')
                // _secondInput = e
                //  setSecondInput(_secondInput)
                setProcess1(true)
            }


            let amount;
            if (which === 1)
                amount = _firsInput
            else amount = _secondInput
            intervalRef.current = setTimeout(() => {
            axios
                .get(
                    SERVER + `/Market/Exchange/${amount}/${sOurce}/${destination}/${which}/`,
                    "accept: text/plain"
                )
                .then(res => {

                    setProcess1(false);
                    setProcess2(false)
                    if (which === 1) {
                        setSecondInput(numberWithCommas(res.data.data.destinationAmount));
                        //source2.current.value=numberWithCommas(res.data.data.destinationAmount.toFixed(12))
                    } else
                        setFirstInput(numberWithCommas(res.data.data.sourceAmount))
                });
                intervalRef.current = null;
            }, 500);
        } else {
            if (which === 1)
                setSecondInput(null);
            else setFirstInput(null)
        }
    }

    function numberWithCommas(x) {
        // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        return x;
    }

    useEffect(() => {
        axios.get(SERVER + "/Market", "accept: text/plain").then(res => {
            setMarkets(res.data.data);
            setMarketsStatic(res.data.data);
        });
    }, []);

    useEffect(() => {
        if (active === 1) {
            setName("IRT");
            setSubname("تومان\nایران");
            setSvg(irrSVG);
            setName2("BTC");
            setSubname2("بیت کوین");
            setSvg2(btcSVG);
        } else if (active === 2) {
            setName2("IRT");
            setSubname2("تومان\nایران");
            setSvg2(irrSVG);
            setSvg(btcSVG);
            setName("BTC");
            setSubname("بیت کوین");
        } else {
            setName2("ETH");
            setSubname2("اتریوم");
            setSvg2(ethSVG);
            setName("BTC");
            setSvg(btcSVG);
            setSubname("بیت کوین");
        }
    }, [active]);

    function toggleFooter(active) {
        if (active === 1) {
            return (
                <div
                    style={{ width: "100%" }}
                    onClick={() => window.location.replace(localStorage.getItem('phone') ? '/userpanel/order' : '/authorization/')}
                >
                    <button className="purchaseButton io" >
                        <i className="fas fa-shopping-cart" />
                        <p style={{ fontWeight: "bold" }}>درخواست خرید</p>
                    </button>

                </div>
            );
        } else if (active === 2) {
            return (
                <div
                    style={{ width: "100%" }}
                    onClick={() => window.location.replace(localStorage.getItem('phone') ? '/userpanel/order' : '/authorization/')}
                >
                    <button className="purchaseButton io" >
                        <i className="fas fa-shopping-cart" />
                        <p style={{ fontWeight: "bold" }}>درخواست فروش</p>
                    </button>
                </div>
            );
        } else {
            return (
                <div
                    style={{ width: "100%" }}
                    onClick={() => window.location.replace(localStorage.getItem('phone') ? '/userpanel/order' : '/authorization/')}
                >
                    <button className="purchaseButton io" >
                        <i className="fas fa-exchange-alt" />
                        <p style={{ fontWeight: "bold" }}>درخواست تبدیل</p>
                    </button>
                </div>
            );
        }
    }

    return (
        <div className="Tmex-Buy-Component">
            <div className="top">
                <div
                    className={"title-items " + (active === 1 ? "active" : "")}
                    onClick={() => {
                        setActive(1);
                        setOpen(false);
                        sOurce = "IRT";
                        destination = "BTC";
                        // source1.current.value = "";
                        //  xToyValue(3,1);
                        setFirstInput('')
                        setSecondInput('')
                        //setexChange(null);
                    }}
                >
                    <i className="fas fa-arrow-circle-down" />
                    <p>خرید</p>
                </div>
                <div
                    className={"title-items " + (active === 2 ? "active" : "")}
                    onClick={() => {
                        setActive(2);
                        setOpen(false);
                        sOurce = "BTC";
                        destination = "IRT";
                        setFirstInput('')
                        setSecondInput('')

                    }}
                >
                    <i className="fas fa-arrow-circle-up" />
                    <p>فروش</p>
                </div>
                <div
                    className={"title-items " + (active === 3 ? "active" : "")}
                    onClick={() => {
                        setActive(3);
                        setOpen(false);
                        sOurce = "BTC";
                        destination = "ETH";
                        setFirstInput('')
                        setSecondInput('')
                    }}
                >
                    <i className="fas fa-exchange-alt" />
                    <p>تبدیل</p>
                </div>
            </div>

            <div className="underTop">
                <div className="body-items">
                    {/*azinja shoro mishe*/}
                    {active === 2 || active === 3 ? (
                        <div ref={sourceDropDownRef} className={`drop-down-toggling ${isOpen ? "opened" : ""}`}>
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        backgroundColor: "white",
                                        borderBottom: "1px solid black"
                                    }}
                                >
                                    <i
                                        class="fas fa-search"
                                        style={{
                                            marginRight: "23px",
                                            marginLeft: "5px",
                                            color: "gray",
                                            fontSize: "17px"
                                        }}
                                    />
                                    <input
                                        className="input"
                                        type="type/text"
                                        placeholder="جستجو"
                                        ref={inputRef2}
                                        onChange={searchHandler}
                                    />

                                </div>
                                {markets &&
                                    markets.filter(item => item.symbol !== destination).map(item => (
                                        <div

                                            className="dd-items"
                                            onClick={() => {
                                                setSvg(SITEURL + `${item.icon}`);
                                                setName(item.symbol);
                                                sOurce = item.symbol;
                                                setSubname(item.name);
                                                inputRef2.current.value = "";
                                                setTimeout(() => setMarkets(marketstatic), 300);
                                                setOpen(!isOpen);
                                                xToyValue(1, firstInput);
                                            }}
                                        >

                                            <div className="icon-svg-dd">
                                                <img
                                                    style={{
                                                        minWidth: "35px",
                                                        minHeight: "35px",
                                                        maxWidth: "35px",
                                                        maxHeight: "35px"
                                                    }}
                                                    src={SITEURL + `${item.icon}`}
                                                    alt={item.symbol}
                                                />
                                            </div>
                                            <div className="name-info-dd">
                                                <p className="subName-info-dd">
                                                    {item.name + "   " + "(" + item.symbol + ")"}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {/*inja dg nmitoone drop downo baz kone*/}

                    {/*azinja statice avalesh shoro mishe*/}
                    <div className="rows">
                        <div className="digitalCurrencies" onClick={() => setOpen(!isOpen)}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex"
                                }}
                            >
                                <div className="icon-svg">
                                    <img
                                        style={{
                                            minWidth: "35px",
                                            minHeight: "35px",
                                            maxWidth: "35px",
                                            maxHeight: "35px"
                                        }}
                                        src={svg}
                                        alt="bitcoin"
                                    />
                                </div>
                                <div className="name-info">
                                    {name}
                                    <p className="subName-info">{subname}</p>
                                </div>
                            </div>
                            {/*in iconam bayad sickesh zade she*/}
                            {active === 2 || active === 3 ? (
                                <i className="fas fa-caret-down dropdown-icon" dir="ltr" />
                            ) : (
                                ""
                            )}
                            {/*in iconam bayad sickesh zade she*/}
                        </div>
                        <div className="cash-input" dir="ltr">
                            <p className="cash">واحد</p>

                            {/*<input*/}
                            {/*    lang="fa"*/}
                            {/*    dir="ltr"*/}
                            {/*    type="number"*/}
                            {/*    onChange={xToyValue}*/}
                            {/*/>*/}
                            {process1 ? < CircularProgress
                                style={{
                                    // minWidth: "25px",
                                    // minHeight: "25px",
                                    // maxHeight: "25x",
                                    // maxWidth: "25px",
                                    width: "23px",
                                    height: "23px",
                                    color: "white"
                                }} /> : <NumberFormat
                                onChange={(e) => xToyValue(1, e.target.value.replaceAll(',', ''))}
                                // onValueChange={(e) => xToyValue(1, e)}
                                className={active === 1 ? 'inputPlace' : 'inputPlace2'}
                                inputmode="numeric"
                                thousandSeparator={true}
                                getInputRef={source1}
                                value={firstInput}
                            />}


                        </div>
                    </div>
                    {/*inja statice avalesh tamoom mishe*/}
                </div>
                {/*dovomi*/}

                <div className="body-items">
                    {/*azinja shoro mishe*/}
                    {active === 1 || active === 3 ? (
                        <div ref={destinationDropDownRef} className={`drop-down-toggling ${isOpen2 ? "opened" : ""}`}>
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        backgroundColor: "white",
                                        borderBottom: "1px solid black"
                                    }}
                                >
                                    <i
                                        class="fas fa-search"
                                        style={{
                                            marginRight: "23px",
                                            marginLeft: "5px",
                                            color: "gray",
                                            fontSize: "17px"
                                        }}
                                    />
                                    <input
                                        className="input"
                                        ref={inputRef}
                                        type="type/text"
                                        placeholder="جستجو"
                                        onChange={searchHandler2}
                                    />
                                </div>
                                {markets &&
                                    markets.filter(item => item.symbol !== sOurce).map(item => (
                                        <div

                                            className="dd-items"
                                            onClick={() => {
                                                setSvg2(SITEURL + `${item.icon}`);
                                                setName2(item.symbol);
                                                destination = item.symbol;
                                                inputRef.current.value = "";
                                                setTimeout(() => setMarkets(marketstatic), 300);
                                                setSubname2(item.name);
                                                setOpen2(!isOpen2);
                                                xToyValue(1, firstInput);
                                            }}
                                        >
                                            <div className="icon-svg-dd">
                                                <img
                                                    style={{
                                                        width: "35px",
                                                        height: "35px"
                                                        // borderRadius: "100%"
                                                    }}
                                                    src={SITEURL + `${item.icon}`}
                                                    alt={item.symbol}
                                                />
                                            </div>
                                            <div className="name-info-dd">
                                                <p className="subName-info-dd">
                                                    {item.name + "   " + "(" + item.symbol + ")"}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {/*inja dg nmitoone drop downo baz kone*/}

                    <div className="rows">
                        <div
                            className="digitalCurrencies"
                            onClick={() => {
                                setOpen2(!isOpen2);
                            }}
                        >
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex" /*position: "relative"} /*flex: 1}*/
                                }}
                            >
                                <div className="icon-svg">
                                    <img
                                        style={{
                                            minWidth: "35px",
                                            minHeight: "35px",
                                            maxWidth: "35px",
                                            maxHeight: "35px"
                                        }}
                                        src={svg2}
                                        alt="bitcoin"
                                    />
                                </div>
                                <div className="name-info">
                                    {name2}
                                    <p className="subName-info">{subname2}</p>
                                </div>
                            </div>
                            {/*in iconam bayad sickesh zade she*/}
                            {active === 1 || active === 3 ? (
                                <i className="fas fa-caret-down dropdown-icon" dir="ltr" />
                            ) : (
                                ""
                            )}
                            {/*in iconam bayad sickesh zade she*/}
                        </div>
                        <div className="cash-input" dir="ltr">
                            <p className="cash-readOnly">واحد</p>
                            {process2 ? < CircularProgress
                                style={{
                                    // minWidth: "25px",
                                    // minHeight: "25px",
                                    // maxHeight: "25x",
                                    // maxWidth: "25px",
                                    width: "23px",
                                    height: "23px",
                                    color: "white"
                                }} /> : <NumberFormat
                                onChange={(e) => xToyValue(2, e.target.value.replaceAll(',', ''))}
                                // onValueChange={(e) => xToyValue(2, e)}
                                className={active === 1 ? 'inputPlace' : 'inputPlace2'}
                                inputmode="numeric"
                                thousandSeparator={true}
                                value={secondInput}
                                getInputRef={source2}

                            />}

                        </div>
                    </div>
                </div>

                {active && toggleFooter(active)}
            </div>
        </div>
    );
};

export default CurrencyComponent;

// {process === true ? (
//   <CircularProgress
//     style={{
//       minWidth: "25px",
//       minHeight: "25px",
//       maxHeight: "25x",
//       maxWidth: "25px",
//       color: "white"
//     }}
//   />
// ) : (
// )}

// <p style={{ color: "white", fontSize: "21px" }}>{exChange}</p>
